import * as React from "react";

function SvgSupport2({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="currentColor"
          d="M12 2.25a7.25 7.25 0 017.246 7.01 2.75 2.75 0 012.499 2.569l.005.171v3a2.75 2.75 0 01-2.582 2.745L19 17.75h-.25V18a2.75 2.75 0 01-2.582 2.745L16 20.75l-1.52.001a2.002 2.002 0 01-1.689 1.242l-.166.007h-1.25c-.977 0-1.8-.704-1.971-1.678l-.022-.156L9.375 20c0-1.054.816-1.918 1.85-1.995l.15-.005h1.25c.827 0 1.544.504 1.848 1.25H16a1.25 1.25 0 001.244-1.122L17.25 18v-.418a1.753 1.753 0 01-.993-1.423L16.25 16v-5c0-.88.65-1.607 1.494-1.731a5.749 5.749 0 00-11.489.001 1.748 1.748 0 011.488 1.576L7.75 11v5a1.75 1.75 0 01-1.607 1.744L6 17.75H5a2.75 2.75 0 01-2.745-2.582L2.25 15v-3c0-1.436 1.1-2.614 2.503-2.74l.012-.237A7.25 7.25 0 0112 2.25zm.625 17.25h-1.25a.506.506 0 00-.493.384l-.008.078.004.09a.498.498 0 00.413.44l.084.008h1.25c.245 0 .45-.177.493-.384l.008-.078-.004-.09a.498.498 0 00-.413-.44l-.084-.008zM19 10.75h-1a.25.25 0 00-.243.193L17.75 11v5a.25.25 0 00.193.243l.057.007h1a1.25 1.25 0 001.244-1.122L20.25 15v-3a1.25 1.25 0 00-1.122-1.244L19 10.75zm-13 0H5a1.25 1.25 0 00-1.244 1.122L3.75 12v3c0 .648.491 1.18 1.122 1.244L5 16.25h1a.25.25 0 00.243-.193L6.25 16v-5a.25.25 0 00-.193-.243L6 10.75z"
        />
      </g>
    </svg>
  );
}

export default SvgSupport2;
